import React from "react";

export const BarkLogo = ({
  size = 44,
  className = "",
  withText = true,
  testId = "bark-logo",
}) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid={testId}>
      <img
        src="/assets/logo.png"
        alt="Bark Buddies logo"
        width={size}
        height={size}
        className="rounded-2xl shadow-bark-soft"
        style={{ width: size, height: size, objectFit: "contain" }}
      />

      {withText && (
        <div className="leading-none">
          <div className="text-[18px] font-extrabold tracking-tight text-bark-ink">
            Bark Buddies
          </div>
          <div className="text-[11px] font-semibold uppercase tracking-widest text-bark-teal">
            Dog Playdate App
          </div>
        </div>
      )}
    </div>
  );
};

export default BarkLogo;